import React, { Suspense, lazy, useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Spinner from "./components/spinner/spinner";
import { StateMachineProvider, createStore } from "little-state-machine";
import { useIdleTimer } from 'react-idle-timer'

const ResourceCategories = lazy(() =>
  import("./components/admin/resource-category")
);
const UCUSAFPhases = lazy(() => import("./components/admin/ucusaf-phases"));
const Currency = lazy(() => import("./components/admin/create-currency"));
const Users = lazy(() => import("./components/admin/user"));
const ServiceArea = lazy(() => import("./components/admin/service-area"));
const Funders = lazy(() => import("./components/admin/funders"));
const AddSSO = lazy(() => import("./components/admin/addSSOCredentials"));

const AddFinancialYear = lazy(() =>
  import("./components/admin/add-financial-year")
);
const ViewUsers = lazy(() => import("./components/admin/view/view-users"));
const ViewFunders = lazy(() => import("./components/admin/view/view-funders"));
const ViewResourceCategories = lazy(() =>
  import("./components/admin/view/view-resource-categories")
);
const ViewServiceAreas = lazy(() =>
  import("./components/admin/view/view-service-area")
);
const ViewUcusafPhases = lazy(() =>
  import("./components/admin/view/view-ucusaf-phases")
);
const ViewCurrencies = lazy(() =>
  import("./components/admin/view/view-currencies")
);
const ViewFinancialYears = lazy(() =>
  import("./components/admin/view/view-financial-year")
);
const Logs = lazy(() => import("./components/admin/view/view-edit-logs"));
const AuditLogs = lazy(() => import("./components/admin/view/view-audit-logs"));


const Dashboard = lazy(() => import("./dashboard/Dashboard"));
const Error401 = lazy(() => import("./error-pages/Error401"));
const Error404 = lazy(() => import("./error-pages/Error404"));
const Error500 = lazy(() => import("./error-pages/Error500"));
const Login = lazy(() => import("./user-profile/Login"));
// general operations
const GeneralInformation = lazy(() =>
  import("./components/projects/create/general-information")
);
const FundingInformation = lazy(() =>
  import("./components/projects/create/project-funding")
);
const RelatedProjects = lazy(() =>
  import("./components/projects/create/related-projects")
);
const MainObjective = lazy(() =>
  import("./components/projects/create/main-objective")
);
const SpecificObjective = lazy(() =>
  import("./components/projects/create/specific-objectives")
);
const ProjectResources = lazy(() =>
  import("./components/projects/create/project-resources")
);
const ProjectLocation = lazy(() =>
  import("./components/projects/create/project-location")
);
const ImplementingEntity = lazy(() =>
  import("./components/projects/create/implementing-entity")
);
const BeneficiaryEntity = lazy(() =>
  import("./components/projects/create/beneficiary-entity")
);
const OtherInformation = lazy(() =>
  import("./components/projects/create/additional-notes")
);
const ViewDetails = lazy(() =>
  import("./components/projects/create/review-details")
);
const ViewAllProjects = lazy(() =>
  import("./components/projects/view-projects")
);

// workplan views
const Workplan = lazy(() => import("./components/workplans/workplan"));

const ViewWorkPlans = lazy(() =>
  import("./components/workplans/view-all-workplans")
);

const ViewSingleWorkplan = lazy(() =>
  import("./components/workplans/viewSingleWorkplan")
);
const ViewMonthlyleWorkplan = lazy(() =>
  import("./components/workplans/monthly")
);
const ViewYearlyWorkplan = lazy(() => import("./components/workplans/yearly"));
const ViewQuaterlyWorkplan = lazy(() =>
  import("./components/workplans/quaterly")
);
// reports
const PerformanceReport = lazy(() =>
  import("./components/Reports/create-reports")
);
const BeneficiaryPerformanceReport = lazy(() =>
  import("./components/Reports/beneficiaryPerformance")
);

const AppRoutes = () => {
  // createStore({});
  const handleOnIdle = (event) => {
    sessionStorage.clear();
    window.open('/','_self');
    console.log('user is idle', event);
    console.log('user is idle', event)
    console.log('last active', getLastActiveTime())
  }

  const handleOnActive = (event) => {
    console.log('user is active', event)
    console.log('time remaining', getRemainingTime())
  }

  const handleOnAction = (event) => {
    console.log('user did something', event)
  }

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 10080000,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500
  });
  const adminPaths=[
    "/dashboard"
  ];
  const requestedPath=window.location.pathname;
  const isLoggedin = sessionStorage.getItem("isLoggedin")==="true";
  

  return (
    <Suspense fallback={<Spinner />}>
      <StateMachineProvider>
        {isLoggedin?
        <Switch>
          <Route exact path="/" component={Login} />
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/error/401" component={Error401} />
          <Route path="/error/404" component={Error404} />
          <Route path="/error/500" component={Error500} />
           <Route path="/admin/edit-logs" component={Logs} />
           <Route path="/admin/audit-logs" component={AuditLogs} />

          <Route
            path="/projects/create/general-information"
            component={GeneralInformation}
          />
          <Route
            path="/projects/create/project-funding"
            component={FundingInformation}
          />
          <Route
            path="/projects/create/related-projects"
            component={RelatedProjects}
          />
          <Route
            path="/projects/create/main-objective"
            component={MainObjective}
          />
          <Route
            path="/projects/create/specific-objectives"
            component={SpecificObjective}
          />
          <Route
            path="/projects/create/project-resources"
            component={ProjectResources}
          />
          <Route
            path="/projects/create/project-locations"
            component={ProjectLocation}
          />
          <Route
            path="/projects/create/implementing-entities"
            component={ImplementingEntity}
          />
          <Route
            path="/projects/create/beneficiary-entities"
            component={BeneficiaryEntity}
          />
          <Route
            path="/projects/create/additional-notes"
            component={OtherInformation}
          />
          <Route path="/projects/view/all" component={ViewAllProjects} />
          <Route path="/projects/view/:id" component={ViewDetails} />
          <Route
            path="/projects/reports/performance"
            component={PerformanceReport}
          />
          <Route
            path="/projects/reports/performance:/id"
            component={PerformanceReport}
          />
          <Route
            path="/projects/reports/beneficiary-performance"
            component={BeneficiaryPerformanceReport}
          />

          <Route path="/projects/workplans/create" component={Workplan} />
          <Route path="/projects/workplans/all" component={ViewWorkPlans} />
          <Route
            path="/projects/workplans/monthly"
            component={ViewMonthlyleWorkplan}
          />
          <Route
            path="/projects/workplans/quaterly"
            component={ViewQuaterlyWorkplan}
          />
          <Route
            path="/projects/workplans/yearly"
            component={ViewYearlyWorkplan}
          />
          <Route
            path="/projects/workplans/view/:id"
            component={ViewSingleWorkplan}
          />

          <Route
            path="/admin/resource-categories/add"
            component={ResourceCategories}
          />
          <Route path="/admin/ucusaf-phases/add" component={UCUSAFPhases} />
          <Route path="/admin/fund-currencies/add" component={Currency} />
          <Route path="/admin/users/add" component={Users} />
          <Route path="/admin/service-areas/add" component={ServiceArea} />
          <Route path="/admin/project-funders/add" component={Funders} />
          <Route path="/admin/financial-years" component={AddFinancialYear} />
          <Route path="/admin/set-sso-credentials" component={AddSSO} />

          <Route path="/admin/users" component={ViewUsers} />
          <Route
            path="/admin/view-financial-years"
            component={ViewFinancialYears}
          />
          <Route path="/admin/fund-currencies" component={ViewCurrencies} />
          <Route path="/admin/project-funders" component={ViewFunders} />
          <Route
            path="/admin/resource-categories"
            component={ViewResourceCategories}
          />
          <Route path="/admin/service-areas" component={ViewServiceAreas} />
          <Route path="/admin/ucusaf-phases" component={ViewUcusafPhases} />

          <Redirect to="/error/404" />
        </Switch>
        :
        <Switch>
        <Route exact path="/" component={Login} />
        <Route path="/error/401" component={Error401} />
        <Redirect to="/error/401"/>
      </Switch>
      
      }
      </StateMachineProvider>
    </Suspense>
  );
};

export default AppRoutes;
